import React, { PureComponent } from "react";
import { connect } from "react-redux";
import { PropTypes } from "prop-types";

import MiscellaneousForm from "../../components/account/MiscellaneousForm.jsx";
import withBasicForm from "../../components/forms/withBasicForm.js";

const MiscellaneousBasicForm = withBasicForm(MiscellaneousForm);

import { selectCopy } from "../../state/reducers/locale/copySelector.js";

class MiscellaneousTab extends PureComponent {
  static propTypes = {
    user: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    copy: PropTypes.func.isRequired
  };

  render() {
    const { user, onSubmit, copy } = this.props;

    return (
      <MiscellaneousBasicForm
        data={user}
        onReset={() => {}}
        onSubmit={onSubmit}
        onFormikSubmit={onSubmit}
        renderMessage={() => null}
        violationErrors={{}}
        copy={copy}
      />
    );
  }
}

const mapStateToProps = state => ({
  copy: selectCopy(state)
});

export default connect(mapStateToProps)(MiscellaneousTab);
